import { BUNDLER_COLLECTION_PRODUCT_FIELDS } from '@app/lib/shopify/queries/fragments/bundler-collection-product-fields';
import { gql } from 'graphql-request';
const bundlerCollectionByHandle = gql`
    query BundlerCollectionByHandleQuery(
        $country: CountryCode
        $handle: String!
        $first: Int
        $after: String
    ) @inContext(country: $country) {
        collection(handle: $handle) {
            handle
            title
            description
            descriptionHtml
            image {
                altText
                transformedSrc(maxWidth: 700)
            }
            products(first: $first, after: $after) {
                edges {
                    cursor
                    node {
                        ...BundlerCollectionProductFields
                    }
                }
                filters {
                    id
                    label
                    type
                    values {
                        id
                        label
                        count
                        input
                    }
                }
                pageInfo {
                    hasNextPage
                }
            }
        }
    }
    ${BUNDLER_COLLECTION_PRODUCT_FIELDS}
`;
export default bundlerCollectionByHandle;
